import "./Modal.css";

export default function Modal({ title, onClose, maxWidth = 480, children }) {
  return (
    <div
      className="wc-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="wc-modal-panel" style={{ maxWidth }}>
        {(title || onClose) && (
          <div className="wc-modal-header">
            {title && <h3 className="wc-modal-title">{title}</h3>}
            {onClose && (
              <button className="wc-modal-close" onClick={onClose} aria-label="Close">✕</button>
            )}
          </div>
        )}
        <div className="wc-modal-body">{children}</div>
      </div>
    </div>
  );
}
